module.exports = __webpack_public_path__ + "static/media/testingMobile.4678c3b6.jpg";